export const WIZARD_PRODUCT_COMPLETED = 'WIZARD_PRODUCT_COMPLETED';
export const WIZARD_PRODUCT_UPDATE_REQUEST = 'WIZARD_PRODUCT_UPDATE_REQUEST';
export const WIZARD_PRODUCT_CREATE_REQUEST = 'WIZARD_PRODUCT_CREATE_REQUEST';
export const WIZARD_PRODUCT_CREATED = 'WIZARD_PRODUCT_CREATED';
export const WIZARD_PRODUCT_UPDATED = 'WIZARD_PRODUCT_UPDATED';
export const WIZARD_PRODUCT_SKIP = 'WIZARD_PRODUCT_SKIP';
export const WIZARD_PRODUCT_SKIP_COMPLETED = 'WIZARD_PRODUCT_SKIP_COMPLETED';
export const WIZARD_PRODUCT_MOVE_REQUEST = 'WIZARD_PRODUCT_MOVE_REQUEST';
export const WIZARD_PRODUCT_MOVE_COMPLETED = 'WIZARD_PRODUCT_MOVE_COMPLETED';
